(ns frontend.view.entity-viewers.modules.tasks.sub
  (:require
   [common.entity :as entity]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [re-frame.core :as rf]
   [ui.components.filter.util :as filter-util]
   [ui.editors.open-search.view :as open-search]
   [ui.page-components.filter-bar.sub :as filter-bar-sub]
   [ui.state.named-values :as named-values]))


(defn resolve-options
  "`tag-options` is passed in rather than read here: task tags are
   named-values, which the new grid does not bulk-sync, so they are resolved
   from the search index by ui.state.named-values and reach us through the
   ::task-filters subscription."
  [field tag-options]
  (let [active-users (->> @session/active-user-accounts-set
                          (map session/get-entity))
        options (case field
                  :task/tag (->> tag-options
                                 (sort-by :label)
                                 (vec))
                  :task/assignee (->> active-users
                                      (map (fn [a]
                                             {:value (:db/id a)
                                              :label (entity/display-string a)}))
                                      (sort-by :label)
                                      (vec))
                  :task/assigner (->> active-users
                                      (map (fn [a]
                                             {:value (:db/id a)
                                              :label (entity/display-string a)}))
                                      (sort-by :label)
                                      (vec))
                  nil)]
    options))

(defn get-options
  [filter search-term callback]
  (let [key-path (:filter/key-path filter)
        field (last key-path)]
    (js/console.log "Debug : " (pr-str field) " >> " search-term)
    (case field
      :task/tag (open-search/get-options
                 {:entity-types          [:entity.type/named-value]
                  :search-query          (or search-term "")
                  :named-value-attribute :task/tag
                  :success-callback!     callback})
      :task/assignee (open-search/get-options
                      {:entity-types      [:entity.type/account]
                       :search-query      (or search-term "")
                       :success-callback! callback})
      nil)))

(def TASK-FILTER-FIELDS
  [{:filter/key-path [:task/completed?]}
   {:filter/key-path    [:task/tag]
    :filter/get-options get-options}
   {:filter/key-path [:task/due]}
   {:filter/key-path [:task/title]}
   {:filter/key-path [:task/created]}
   {:filter/key-path    [:task/assignee]
    :filter/get-options get-options}
   ;:task/assigner
   ])

(rf/reg-sub
 ::all-tasks
 (fn [_db]
   @session/tasks))

(rf/reg-sub
 ::view-tasks
 :<-
 [::all-tasks]
 (fn [all-tasks [_ viewed-entity-id]]
   (->> all-tasks
        (filter (fn [task]
                  (some #{viewed-entity-id}
                        (:common/related-entities task)))))))
(rf/reg-sub
 ::tenant-schema
 (fn [_db]
   @session/tenant-schema))

(rf/reg-sub
 ::tenant
 (fn [_db]
   @session/tenant))


(rf/reg-sub
 ::task-filters
 :<-
 [::tenant-schema]
 :<-
 [::named-values/options :task/tag]
 (fn [[tenant-schema tag-options] _]
   (->> TASK-FILTER-FIELDS
        (keep (fn [{:keys [filter/key-path filter/get-options] :as filter}]
                (let [f (last key-path)]
                  (when (f-permissions/field-read-access? f :entity.type/task nil)
                    (filter-util/resolve-field-filter tenant-schema
                                                      (when-not get-options
                                                        (resolve-options f tag-options))
                                                      filter)))))
        (vec))))

(rf/reg-sub
 ::init-filters
 :<-
 [::task-filters]
 (fn [task-filters _]
   (->> task-filters
        (cu/filter-by :filter/key-path [:task/completed?])
        (mapv (fn [filter]
                (case (last (:filter/key-path filter))
                  :task/completed?
                  (assoc filter :filter/operator :filter-operator/is-false)
                  filter))))))

(rf/reg-sub
 ::visible-task-entities
 :<-
 [::all-tasks]
 :<-
 [::filter-bar-sub/filters]
 (fn [[all-tasks filters] [_ component-id viewed-entity-id]]
   (let [component-filters (get filters component-id)]
     (->> all-tasks
          (filter (fn [task]
                    (some #{viewed-entity-id}
                          (:common/related-entities task))))
          (filter (fn [e]
                    (->> component-filters
                         (remove (fn [filter-item]
                                   (let [match? (filter-util/filter! filter-item e)]
                                     match?)))
                         (empty?))))
          (sort (fn [a b]
                  (let [a-due (:task/due a)
                        b-due (:task/due b)
                        a-title (:task/title a)
                        b-title (:task/title b)
                        a-message (:task/message a)
                        b-message (:task/message b)
                        due-compare (compare a-due b-due)
                        title-compare (compare a-title b-title)
                        a-title? (not (cu/blank-value? a-title))
                        b-title? (not (cu/blank-value? b-title))
                        message-compare (compare a-message b-message)
                        res (cond (and a-due b-due (not (zero? due-compare)))
                                  due-compare
                                  a-due
                                  -1
                                  b-due
                                  1
                                  (and a-title? b-title? (not (zero? title-compare)))
                                  title-compare
                                  (and a-title? (not b-title?))
                                  -1
                                  (and b-title? (not a-title?))
                                  1
                                  :else
                                  message-compare)]
                    res
                    )))
          ))))
